import React, {FunctionComponent} from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {ACard} from "@atiautomacao/ati-ui-library";
import {Equipment} from "../../Modules/Dashboard/Skid/EquipmentDetailsSkid/EquipmentDetailsSkidReducer";
import {MenuItemStatus} from "./Layout/menu/types/MenuItemStatus";
import {getStatusName} from "./Layout/menu/helpers/getStatusName";
import {DateFormat} from "../../Utils/DateFormatPatternUtils";

interface EquipmentBasicInfoProps {
    equipment?: Equipment;
    status?: MenuItemStatus;
    title?: string;
}

const EquipmentBasicInfo: FunctionComponent<EquipmentBasicInfoProps> = ({equipment, status, title = "Informações Básicas"}) => {
    return (
        <ACard styleProps={{
                            subTitleStyle: {padding: 0},
                            titleStyle: {
                                fontFamily: 'Work Sans',
                                fontWeight: 600,
                                fontSize: '1rem',
                                lineHeight: '150%',
                                letterSpacing: '0.15px',
                            }
                          }}
               title={title}>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={6} xl={4}>
                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                    >
                        Status:

                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ paddingLeft: 4 }}
                        >
                            {status ? getStatusName(status) : "-"}
                        </Typography>


                    </Typography>

                </Grid>

                <Grid item xs={12} lg={6} xl={4}>
                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                    >
                        Última Atualização:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ paddingLeft: 4 }}
                        >
                            {equipment?.lastDateTime ? DateFormat(equipment.lastDateTime) : "-"}
                        </Typography>
                    </Typography>

                </Grid>

                <Grid item xs={12} lg={6} xl={4} >
                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                    >
                        Serie:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={14}
                            style={{ paddingLeft: 4 }}
                        >
                            {equipment?.seriesNumber ? equipment.seriesNumber : " -"}
                        </Typography>

                    </Typography>

                </Grid>


                <Grid item xs={12} lg={6} xl={4}>
                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                        style={{ alignItems: "center" }}
                    >
                        Classe de Equipamento:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ alignItems: "center", paddingLeft: 4 }}
                        >
                            {equipment?.equipmentClass ? equipment.equipmentClass : "-"}
                        </Typography>
                    </Typography>
                </Grid>

                <Grid item xs={12} lg={6} xl={4}>

                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                        style={{ alignItems: "center" }}
                    >
                        Sigla:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ alignItems: "center", paddingLeft: 4 }}
                        >
                            {equipment?.abbreviation ? equipment.abbreviation : " -"}
                        </Typography>
                    </Typography>

                </Grid>

                <Grid item xs={12} lg={6} xl={4}>

                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                        style={{ alignItems: "center" }}
                    >

                        Endereço IP:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ alignItems: "center", paddingLeft: 4 }}
                        >
                            {equipment?.utrIpAddress ? equipment.utrIpAddress : "-"}
                        </Typography>
                    </Typography>

                </Grid>

                <Grid item xs={12} lg={6} xl={4}>
                    <Typography
                        variant="h2" display={"flex"}
                        fontWeight={700} fontSize={16}
                        style={{ alignItems: "center" }}
                    >
                        Descrição:
                        <Typography
                            variant="h2" display={"flex"}
                            fontSize={16}
                            style={{ alignItems: "center", paddingLeft: 4 }}
                        >
                            {equipment?.description ? equipment.description : "-"}
                        </Typography>
                    </Typography>
                </Grid>
            </Grid>
        </ACard>
    );
}

export default EquipmentBasicInfo;
